import { render, staticRenderFns } from "./EditUserIcon.vue?vue&type=template&id=37c1ea3a&scoped=true&"
import script from "./EditUserIcon.vue?vue&type=script&lang=js&"
export * from "./EditUserIcon.vue?vue&type=script&lang=js&"
import style0 from "./EditUserIcon.vue?vue&type=style&index=0&id=37c1ea3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c1ea3a",
  null
  
)

export default component.exports